import { DocumentSyncOutlineIcon } from '@applyboard/ui-icons';
import { Flex, Text } from '@applyboard/crystal-ui';
import { useAppProcessing } from '~/pages/ApplicationDetails/context';

import { Card } from './Card';
import { formatDate } from '~/utils';

export function AlternateProgramInformation() {
  const {
    application: { alternateProgramsIntake = [] },
  } = useAppProcessing();

  return (
    <Card id="alternateProgram" icon={DocumentSyncOutlineIcon} title="Alternate Program" hideChevron>
      <Flex justify="start" direction="column">
        {alternateProgramsIntake.length > 0 ? (
          <Flex direction="column" gap={4}>
            {alternateProgramsIntake.map((alternateProgramIntake) => {
              const key = crypto.randomUUID();

              return (
                <Flex key={key} direction="column" gap={4}>
                  <Flex direction="column" gap={2}>
                    <Text variant="labelL">{alternateProgramIntake.program?.name}</Text>
                    <Flex gap={2} wrap>
                      <Flex gap={2}>
                        <Text variant="labelM" as="span">
                          Program Code
                        </Text>
                        <Text as="span">{alternateProgramIntake.program?.code ?? '--'}</Text>
                        <VerticalDivider />
                      </Flex>
                      <Flex gap={2}>
                        <Text variant="labelM" as="span">
                          Intake
                        </Text>
                        <Text as="span">{formatIntakeTermStartDate(alternateProgramIntake.intakeTerm?.startDate)}</Text>
                        <VerticalDivider />
                      </Flex>
                      <Flex gap={2}>
                        <Text variant="labelM" as="span">
                          Campus
                        </Text>
                        <Text as="span">{alternateProgramIntake.campus?.name ?? '--'}</Text>
                      </Flex>
                    </Flex>
                  </Flex>
                </Flex>
              );
            })}
          </Flex>
        ) : (
          <Text variant="bodyL">No alternate program selected</Text>
        )}
      </Flex>
    </Card>
  );
}

function VerticalDivider() {
  return (
    <Text contrast="low" intent="secondary" as="span">
      |
    </Text>
  );
}

function formatIntakeTermStartDate(date?: string) {
  if (!date) {
    return '--';
  }

  return formatDate(new Date(date), {
    month: 'short',
    day: undefined,
    year: 'numeric',
  });
}
